import { Vector3 } from 'three';

// KiCad board: 0..200 mm (X), 0..110 mm (Y).
// KiCad's GLB exporter centers the board and converts millimetres to metres.
export function kicadToWorld(xMm: number, yMm: number, height = 0.0125): Vector3 {
  return new Vector3((xMm - 100) / 1000, height, (yMm - 55) / 1000);
}
